import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, createVNode as _createVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "container" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "no-gutters text-center pb-3" }, [
  /*#__PURE__*/_createElementVNode("span", {
    property: "itemListElement",
    typeof: "ListItem"
  }, [
    /*#__PURE__*/_createElementVNode("a", {
      property: "item",
      typeof: "WebPage",
      title: "Go to EveryLink.",
      href: "/",
      class: "home"
    }, [
      /*#__PURE__*/_createElementVNode("span", { property: "name" }, "EveryLink")
    ]),
    /*#__PURE__*/_createElementVNode("meta", {
      property: "position",
      content: "1"
    })
  ]),
  /*#__PURE__*/_createElementVNode("span", {
    property: "itemListElement",
    typeof: "ListItem"
  }, [
    /*#__PURE__*/_createElementVNode("span", { class: "d" }, " > "),
    /*#__PURE__*/_createElementVNode("a", {
      property: "item",
      typeof: "WebPage",
      title: "Go to EveryLink.",
      href: "/people",
      class: "home"
    }, [
      /*#__PURE__*/_createElementVNode("span", { property: "name" }, "People")
    ]),
    /*#__PURE__*/_createElementVNode("meta", {
      property: "position",
      content: "1"
    })
  ]),
  /*#__PURE__*/_createElementVNode("span", {
    property: "itemListElement",
    typeof: "ListItem"
  }, [
    /*#__PURE__*/_createElementVNode("span", { class: "d" }, " > "),
    /*#__PURE__*/_createElementVNode("a", {
      property: "item",
      typeof: "WebPage",
      title: "Go to EveryLink.",
      href: "/profile-edit",
      class: "home"
    }, [
      /*#__PURE__*/_createElementVNode("span", { property: "name" }, "Edit Profile")
    ]),
    /*#__PURE__*/_createElementVNode("meta", {
      property: "position",
      content: "1"
    })
  ]),
  /*#__PURE__*/_createElementVNode("span", {
    property: "itemListElement",
    typeof: "ListItem"
  }, [
    /*#__PURE__*/_createElementVNode("span", { class: "d" }, " > "),
    /*#__PURE__*/_createElementVNode("span", { property: "name" }, "Manage Friends"),
    /*#__PURE__*/_createElementVNode("meta", {
      property: "position",
      content: "3"
    })
  ])
], -1)
const _hoisted_3 = { class: "d-flex justify-content-center" }
const _hoisted_4 = { class: "row no-gutters" }
const _hoisted_5 = { class: "col-12 text-center" }
const _hoisted_6 = {
  key: 1,
  class: "d-inline-block align-middle"
}
const _hoisted_7 = { class: "row no-gutters" }
const _hoisted_8 = { class: "col-12 text-center" }
const _hoisted_9 = { key: 1 }
const _hoisted_10 = { class: "row justify-content-center text-center mt-5" }
const _hoisted_11 = { class: "card border p-0" }
const _hoisted_12 = { class: "card-header border-bottom py-3" }
const _hoisted_13 = { class: "card-header-title mb-0" }
const _hoisted_14 = { class: "badge bg-primary d-inline-block" }
const _hoisted_15 = { class: "card-body m-2 mt-4" }
const _hoisted_16 = {
  key: 0,
  class: "list-group text-start m-0 p-0"
}
const _hoisted_17 = {
  key: 1,
  class: "list-group text-start m-0 p-0"
}
const _hoisted_18 = { class: "ms-2 me-auto" }
const _hoisted_19 = { class: "fw-bold" }
const _hoisted_20 = ["onClick"]
const _hoisted_21 = /*#__PURE__*/_createElementVNode("span", { class: "px-1 text-light text-decoration-none" }, "Accept", -1)
const _hoisted_22 = [
  _hoisted_21
]
const _hoisted_23 = ["onClick"]
const _hoisted_24 = /*#__PURE__*/_createElementVNode("span", { class: "px-1 text-light text-decoration-none" }, "Reject", -1)
const _hoisted_25 = [
  _hoisted_24
]
const _hoisted_26 = { class: "row justify-content-center text-center mt-5" }
const _hoisted_27 = { class: "card border p-0" }
const _hoisted_28 = { class: "card-header border-bottom py-3" }
const _hoisted_29 = { class: "card-header-title mb-0" }
const _hoisted_30 = { class: "badge bg-secondary d-inline-block" }
const _hoisted_31 = { class: "card-body m-2 mt-4" }
const _hoisted_32 = {
  key: 0,
  class: "list-group text-start m-0 p-0"
}
const _hoisted_33 = {
  key: 1,
  class: "list-group text-start m-0 p-0"
}
const _hoisted_34 = { class: "ms-2 me-auto" }
const _hoisted_35 = { class: "fw-bold" }
const _hoisted_36 = /*#__PURE__*/_createElementVNode("span", { class: "px-1 text-light text-decoration-none" }, "View", -1)
const _hoisted_37 = ["onClick"]
const _hoisted_38 = /*#__PURE__*/_createElementVNode("span", { class: "px-1 text-light text-decoration-none" }, "Unblock", -1)
const _hoisted_39 = [
  _hoisted_38
]
const _hoisted_40 = ["onClick"]
const _hoisted_41 = /*#__PURE__*/_createElementVNode("span", { class: "px-1 text-light text-decoration-none" }, "Block", -1)
const _hoisted_42 = [
  _hoisted_41
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Skeletor = _resolveComponent("Skeletor")!
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      (_ctx.isLoading)
        ? (_openBlock(), _createBlock(_component_Skeletor, {
            key: 0,
            class: "my-3",
            circle: "",
            size: "120"
          }))
        : (_openBlock(), _createElementBlock("div", {
            key: 1,
            class: "avatar my-3",
            style: _normalizeStyle({ backgroundImage: `url(${_ctx.getAvatar})` })
          }, null, 4))
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", _hoisted_5, [
        (_ctx.isLoading)
          ? (_openBlock(), _createBlock(_component_Skeletor, {
              key: 0,
              class: "mx-auto mb-2",
              width: "300",
              height: "35"
            }))
          : (_openBlock(), _createElementBlock("h2", _hoisted_6, _toDisplayString(_ctx.getFullName), 1))
      ])
    ]),
    _createElementVNode("div", _hoisted_7, [
      _createElementVNode("div", _hoisted_8, [
        _createElementVNode("p", null, [
          _createTextVNode(" You have "),
          (_ctx.isLoading)
            ? (_openBlock(), _createBlock(_component_Skeletor, {
                key: 0,
                class: "mx-auto d-inline-block",
                width: "15",
                height: "10"
              }))
            : (_openBlock(), _createElementBlock("b", _hoisted_9, _toDisplayString(_ctx.getFriends?.length), 1)),
          _createTextVNode(" Friends ")
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_10, [
      _createElementVNode("div", _hoisted_11, [
        _createElementVNode("div", _hoisted_12, [
          _createElementVNode("h4", _hoisted_13, [
            _createTextVNode("New Friend Requests "),
            _createElementVNode("span", _hoisted_14, _toDisplayString(_ctx.getFriendRequests?.length), 1)
          ])
        ]),
        _createElementVNode("div", _hoisted_15, [
          (_ctx.isLoading)
            ? (_openBlock(), _createElementBlock("ol", _hoisted_16, [
                (_openBlock(), _createElementBlock(_Fragment, null, _renderList(3, (index) => {
                  return _createVNode(_component_Skeletor, {
                    key: index,
                    class: "mx-auto mb-3",
                    width: "100%",
                    height: "50",
                    pill: ""
                  })
                }), 64))
              ]))
            : (_openBlock(), _createElementBlock("ol", _hoisted_17, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.getFriendRequests, (friendRequest) => {
                  return (_openBlock(), _createElementBlock("li", {
                    key: friendRequest._id,
                    class: "list-group-item d-flex justify-content-between align-items-center"
                  }, [
                    _createElementVNode("div", {
                      class: "avatar avatar--mini flex-shrink-0 me-1",
                      style: _normalizeStyle({ backgroundImage: `url(${friendRequest.sender.avatar})` })
                    }, null, 4),
                    _createElementVNode("div", _hoisted_18, [
                      _createElementVNode("div", _hoisted_19, _toDisplayString(friendRequest.sender.firstName) + " " + _toDisplayString(friendRequest.sender.lastName), 1),
                      _createTextVNode(" Friend request ")
                    ]),
                    _createElementVNode("button", {
                      onClick: ($event: any) => (_ctx.acceptRequest(friendRequest.sender._id)),
                      class: "badge d-flex p-2 align-items-center text-bg-primary rounded-pill"
                    }, _hoisted_22, 8, _hoisted_20),
                    _createElementVNode("button", {
                      onClick: ($event: any) => (_ctx.rejectRequest(friendRequest.sender._id)),
                      class: "badge d-flex p-2 align-items-center text-bg-secondary rounded-pill ms-2"
                    }, _hoisted_25, 8, _hoisted_23)
                  ]))
                }), 128))
              ]))
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_26, [
      _createElementVNode("div", _hoisted_27, [
        _createElementVNode("div", _hoisted_28, [
          _createElementVNode("h4", _hoisted_29, [
            _createTextVNode("Manage Friends "),
            _createElementVNode("span", _hoisted_30, _toDisplayString(_ctx.getFriends?.length), 1)
          ])
        ]),
        _createElementVNode("div", _hoisted_31, [
          (_ctx.isLoading)
            ? (_openBlock(), _createElementBlock("ol", _hoisted_32, [
                (_openBlock(), _createElementBlock(_Fragment, null, _renderList(3, (index) => {
                  return _createVNode(_component_Skeletor, {
                    key: index,
                    class: "mx-auto mb-3",
                    width: "100%",
                    height: "50",
                    pill: ""
                  })
                }), 64))
              ]))
            : (_openBlock(), _createElementBlock("ol", _hoisted_33, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.getFriends, (friend) => {
                  return (_openBlock(), _createElementBlock("li", {
                    key: friend._id,
                    class: "list-group-item d-flex justify-content-between align-items-center"
                  }, [
                    _createElementVNode("div", {
                      class: "avatar avatar--mini flex-shrink-0 me-1",
                      style: _normalizeStyle({ backgroundImage: `url(${friend._id.avatar})` })
                    }, null, 4),
                    _createElementVNode("div", _hoisted_34, [
                      _createElementVNode("div", _hoisted_35, _toDisplayString(friend._id.firstName) + " " + _toDisplayString(friend._id.lastName), 1)
                    ]),
                    _createVNode(_component_router_link, {
                      to: `/person/?id=${friend._id.wpId}`,
                      class: "badge d-flex p-2 align-items-center text-bg-primary rounded-pill"
                    }, {
                      default: _withCtx(() => [
                        _hoisted_36
                      ]),
                      _: 2
                    }, 1032, ["to"]),
                    (friend.blockFriend)
                      ? (_openBlock(), _createElementBlock("button", {
                          key: 0,
                          onClick: ($event: any) => (_ctx.unblockFriend(friend._id._id)),
                          class: "badge d-flex p-2 align-items-center text-bg-secondary rounded-pill ms-2"
                        }, _hoisted_39, 8, _hoisted_37))
                      : (_openBlock(), _createElementBlock("button", {
                          key: 1,
                          onClick: ($event: any) => (_ctx.blockFriend(friend._id._id)),
                          class: "badge d-flex p-2 align-items-center text-bg-secondary rounded-pill ms-2"
                        }, _hoisted_42, 8, _hoisted_40))
                  ]))
                }), 128))
              ]))
        ])
      ])
    ])
  ]))
}